export default {
  initial: {
    query: '',
    platforms: [],
    type: '',
    strategy_types: [],
  },
  configuration: {
    query: {
      order: 1,
      subbutton: { isVisible: (value = '') => !!value },
      label: 'recommendations::type.filters.query.label',
      placeholder: 'recommendations::type.filters.query.placeholder',
      type: 'input',
    },
    platforms: {
      order: 2,
      showEmptyOption: true,
      subbutton: {
        isVisible: (value = [], breakpoints) =>
          value.length > 0 || !!breakpoints.fb,
      },
      label: 'recommendations::type.filters.platforms.label',
      type: 'select',
      multiple: true,
      optionLabelPrefix: 'recommendations::type.filters.platforms.options.',
      renderEmptyOptionAsOption: true,
      emptyOptionLabel:
        'recommendations::type.filters.platforms.empty_option_label',
      options: [
        'search',
        'context',
        'partner',
        'maps',
        'context_maps',
        'search_maps',
        'search_context_maps',
        'search_context',
        'other',
      ],
    },
    type: {
      order: 2,
      subbutton: { isVisible: (value = '') => !!value },
      placeholder: 'recommendations::type.filters.type.label',
      label: 'recommendations::type.filters.type.label',
      type: 'input',
      noIcon: true,
    },
    strategy_types: {
      order: 2,
      subbutton: {
        isVisible: (value = [], breakpoints) =>
          value.length > 0 || !!breakpoints.fb,
      },
      label: 'recommendations::type.filters.strategy_types.label',
      type: 'select',
      multiple: true,
      emptyOptionLabel: 'common::select_empty_option',
      optionLabelPrefix:
        'recommendations::type.filters.strategy_types.options.',
      options: ['auto_c', 'auto_nc', 'manual'],
    },
  },
}
